// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk~" + chunkId + "_" + {"6":"8815e02d6bab15f6ed14","741":"8252556ec2a4650d3ba8"}[chunkId] + ".js";
};